import { Box, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import * as Preact from 'preact';

export interface Props {
    name?: string;
    minPrice?: string;
}

export const Component = (p: Props) => {
    const theme = useTheme();
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Typography variant="body2" fontWeight={600} color={theme.palette.text.primary}>
                {p.name}
            </Typography>
            {p.minPrice && <Typography variant="body2bold">{`from ${p.minPrice}`}</Typography>}
        </Box>
    );
};

Component.displayName = 'MaterialHeader';
